<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: "projectProgress-wrapper"
};
</script>

<style>
</style>